import React from 'react';
import Button from './Button';

const ButtonPrimary = ({
  className = '',
  ariaLabel ='',
  ...args
}) => {
  return (
    <Button
      className={`rounded-full bg-primary text-white hover:bg-primary/80 disabled:bg-opacity-70 ${className}`}
      ariaLabel={ariaLabel}
      {...args}
    />
  );
};

export default ButtonPrimary;
